import styled from "styled-components/macro";
import { Text } from "../../../../components";

export const Caption = styled(Text)`
  color: ${({ theme }) => theme.color.neutral["03"]};
`;

export default null;
